import React from "react";
import UpcomingBirthdayDataBuilder from "../data/UpcomingBirthdayDataBuilder";
import { UpcomingBirthdayUsersEditorContainer } from "./styled";

function UpcomingBirthdayEditor() {
  return (
    <UpcomingBirthdayUsersEditorContainer>
      <UpcomingBirthdayDataBuilder />
    </UpcomingBirthdayUsersEditorContainer>
  );
}

export default UpcomingBirthdayEditor;
